import { Step } from "../types/Step";

export const stepPercentage = {
  [Step.COSA]: 10,
  [Step.SCONTO]: 100,
};
